module.exports = __webpack_public_path__ + "img/6.cfc0b2c9.gif";